<div class="gap-1 b-radius-wide overflow width-mobile-full" [ngClass]="user.isInternal ? 'grid-6 c1240-grid-3 c620-grid-6-i' : 'grid-3'">
  @for (card of countersCards; track $index) {
    @if (card) {
      <div class="am-flex-align gap-m p-m hover-active animate-bg c620-flex-column c620-p-xs c620-gap-xs" (click)="changeDashboard(card)"
          [class.bg-white]="  !isActive(card)"
          [class.bg-blue]="    isActive(card)"
          [class.color-white]="isActive(card)">
        @if (card?.icon) { 
          <span class="am-flex-center p-xs b-radius font-icon-small c620-font-l" [ngClass]="card.icon"
              [class.bg-overlay-white-15]="isActive(card)"
              [class.bg-basic-grey]="     !isActive(card)">
          </span>
        }
        <span class="am-flex-column am-flex-justify">
          @if (card?.identifier) {
            <span class="lh-1 font-22 c620-font-m"
                [class.color-orange]="card.identifier === 'ar-failed-erp'"
                [class.color-white-i]="isActive(card)">{{ mapCardCount(card.identifier) }}
            </span>
          }
          @if (card?.title && card?.identifier) {
            <div class="am-flex-column c620-hide">
              <span class="text-s">{{ mapCardTitle(card.identifier) }}</span>
              <span class="text-xs">{{ mapCardSubtitle(card.identifier) }}</span>
            </div>
          }
        </span>
      </div>
    }
  }
</div>
